<div class="header">
  <lucide-icon [name]="iconMap[identifier().icon] ?? identifier().icon" size="16"></lucide-icon>
  <h4>{{ label() }}</h4>
</div>
<ts-divider spacing="none"></ts-divider>
<div class="saved-views-group">
  <ts-icon [icon]="'ts_window-section'" iconColor="black"></ts-icon> Saved Views
  <ts-button type="icon" icon="ts_plus" iconColor="black" (click)="openNewViewDialog()"></ts-button>
</div>
<ts-tree-menu
  sidenav
  [suppressHeader]="true"
  [items]="views()"
  [loading]="isLoading()"
  [delegateLeafClickFn]="delegateLeafClickFn.bind(this)"
  [smallSkeleton]="true"
></ts-tree-menu>
